import { Component } from '@angular/core';

@Component({
  selector: 'customer-forgot-password',
  templateUrl: './custom-forgot-password.component.html',
  styleUrls: ['./custom-forgot-password.component.scss'],
})
export class CustomForgotPasswordComponent {}
